<section
  class="ch-api-dashboard"
  [class.ch-api-dashboard--dark]="isDarkMode"
  *ngIf="selectedImo"
>
  <div class="ch-api-dashboard__loading" *ngIf="loading">
    <mat-spinner diameter="28"></mat-spinner>
    <span>Loading onboarding details for IMO {{ selectedImo }}…</span>
  </div>

  <ng-container *ngIf="!loading && view as dashboard">
    <div class="ch-api-dashboard__summary">
      <div class="ch-api-summary__item">
        <span class="ch-api-summary__label">Vessel Name</span>
        <span class="ch-api-summary__value">{{ dashboard.summary.vesselName }}</span>
      </div>
      <div class="ch-api-summary__item">
        <span class="ch-api-summary__label">IMO Number</span>
        <span class="ch-api-summary__value">{{ dashboard.summary.imo }}</span>
      </div>
      <div class="ch-api-summary__item">
        <span class="ch-api-summary__label">Client ID</span>
        <span class="ch-api-summary__value">{{ dashboard.summary.clientId }}</span>
      </div>
      <div class="ch-api-summary__item">
        <span class="ch-api-summary__label">Segment</span>
        <span class="ch-api-summary__value">{{ dashboard.summary.segment }}</span>
      </div>
      <div class="ch-api-summary__item">
        <span class="ch-api-summary__label">Vessel Type</span>
        <span class="ch-api-summary__value">{{ dashboard.summary.vesselType }}</span>
      </div>
      <div class="ch-api-summary__item">
        <span class="ch-api-summary__label">Tanker Type</span>
        <span class="ch-api-summary__value">{{ dashboard.summary.tankerType }}</span>
      </div>
    </div>

    <div class="ch-api-dashboard__cards">
      <article
        class="ch-api-card"
        *ngFor="let section of dashboard.cardSections; trackBy: trackSection"
      >
        <header class="ch-api-card__header">
          <h3 class="ch-api-card__title">{{ section.title }}</h3>
        </header>
        <div class="ch-api-card__body">
          <table class="ch-api-kv-table">
            <tbody>
              <tr *ngFor="let row of section.rows">
                <th>{{ row.label }}</th>
                <td *ngIf="!row.moduleKeys?.length" [title]="row.value">{{ row.value }}</td>
                <td *ngIf="row.moduleKeys?.length" class="ch-api-module-badges">
                  <span
                    class="onboarding-module-badge"
                    [ngClass]="moduleBadgeClass(moduleKey)"
                    *ngFor="let moduleKey of row.moduleKeys; trackBy: trackModuleKey"
                  >
                    {{ formatModuleLabel(moduleKey) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </article>

      <article class="ch-api-card ch-api-card--files">
        <header class="ch-api-card__header">
          <h3 class="ch-api-card__title">Uploaded Documents</h3>
        </header>
        <div class="ch-api-card__body ch-api-card__body--files">
          <table class="ch-api-files-table" *ngIf="dashboard.uploadedFiles.length">
            <colgroup>
              <col class="ch-api-files-table__col-type" />
              <col class="ch-api-files-table__col-name" />
              <col class="ch-api-files-table__col-meta" />
              <col class="ch-api-files-table__col-meta" />
              <col class="ch-api-files-table__col-actions" />
            </colgroup>
            <thead>
              <tr>
                <th>Document Type</th>
                <th>File Name</th>
                <th>File Type</th>
                <th>File Size</th>
                <th class="ch-api-files-table__actions-col">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let file of dashboard.uploadedFiles; trackBy: trackFile">
                <td class="ch-api-files-table__type">{{ file.documentType }}</td>
                <td class="ch-api-files-table__name" [title]="file.fileName">
                  {{ file.fileName }}
                </td>
                <td class="ch-api-files-table__meta">{{ file.mimeType || '—' }}</td>
                <td class="ch-api-files-table__meta">{{ formatFileSize(file.sizeBytes) }}</td>
                <td class="ch-api-files-table__actions">
                  <button
                    type="button"
                    class="ch-api-file-btn"
                    [disabled]="!canPreviewFile(file)"
                    (click)="previewFile(file, $event)"
                    [attr.aria-label]="'Preview ' + file.fileName"
                    matTooltip="Preview"
                  >
                    <mat-icon>visibility</mat-icon>
                  </button>
                  <button
                    type="button"
                    class="ch-api-file-btn"
                    [disabled]="!canDownloadFile(file)"
                    (click)="downloadFile(file, $event)"
                    [attr.aria-label]="'Download ' + file.fileName"
                    matTooltip="Download"
                  >
                    <mat-icon>download</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <p class="ch-api-empty" *ngIf="!dashboard.uploadedFiles.length">
            No uploaded documents available.
          </p>
        </div>
      </article>
    </div>

    <div class="ch-api-dashboard__tables">
      <article
        class="ch-api-card ch-api-card--table"
        [class.ch-api-card--table-full]="table.spanFull"
        *ngFor="let table of dashboard.tableSections; trackBy: trackTableSection"
      >
        <header class="ch-api-card__header">
          <h3 class="ch-api-card__title">{{ table.title }}</h3>
        </header>
        <div class="ch-api-card__body ch-api-card__body--scroll">
          <table class="ch-api-data-table" *ngIf="table.rows.length">
            <thead>
              <tr>
                <th *ngFor="let header of table.headers">{{ header }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of table.rows">
                <td *ngFor="let cell of row" [title]="cell">{{ cell }}</td>
              </tr>
            </tbody>
          </table>
          <p class="ch-api-empty" *ngIf="!table.rows.length">
            {{ table.emptyMessage || 'No data available for this section.' }}
          </p>
        </div>
      </article>
    </div>
  </ng-container>

  <p class="ch-api-empty ch-api-empty--page" *ngIf="!loading && !view">
    No onboarding data is available for the selected vessel.
  </p>
</section>
